<section>
  <h2>NIBIN Leads/Hits</h2>
  <p>Each row of data represents a single 1 to 1 link, which corresponds to a single lead/hit in the NIBIN database.  NESS consolidates these hits/leads into one Crime Gun ID.  If there is a date in the "Confirmation Date" column, then that particular row is a confirmed hit (i.e. microscopically verified).</p>
  <figure class="figure">
    <div>
      <img src="assets/images/nibinlinkscasings.jpg" id="casingImg" class="figure-img img-fluid rounded" alt="Illustration of shell casings with linked hits and leads." />
      <img src="assets/images/nibinlinkssampletable.png" id="tableImg" class="figure-img img-fluid rounded" alt="Table with sample NIBIN 1:1 links data." />
    </div>
    <figcaption class="figure-caption">The shell casing diagram and table above is an example of how these hits/leads are created in NIBIN and what the corresponding list in NESS will show.  NOTES: There may be more or less 1 to 1 hits/leads.  In the example above, even though A is not directly linked to D, A linked to C and C linked to D, therefore A is linked to D.  There does not have to be a listed link between each piece of evidence for the links to exist.</figcaption>
  </figure>
  <div>
    <p-table #dt [columns]="cols" [value]="linkedHitsData" [paginator]="true" [rows]="rows" selectionMode="multiple" [(selection)]="selectedHitsData" [autoLayout]="true" responsiveLayout="scroll" [alwaysShowPaginator]="false" [exportFunction]="prepareExportData">
      <ng-template pTemplate="caption">
        <div class="p-2">
          <button type="button" class="btn btn-success" (click)="exportCSV()"><i class="fas fa-download"></i> Export .csv (all records)</button>
          <button type="button" class="btn btn-success" [disabled]="selectedHitsData.length == 0" (click)="exportCSV({selectionOnly: true})"><i class="fas fa-tasks"></i> Export .csv (only selected records)</button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" scope="col" class="text-nowrap">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns" [ngSwitch]="col.field" class="text-nowrap">
            <ng-container *ngSwitchCase="'RefLabCaseNumber'">{{ rowData[col.field]}}</ng-container>
            <ng-container *ngSwitchCase="'TestLabCaseNumber'">{{ rowData[col.field]}}</ng-container>
            <ng-container *ngSwitchCase="'CreatedTime'">{{ rowData[col.field] | localToUtc:'MM/dd/yyyy' }}</ng-container>
            <ng-container *ngSwitchCase="'ConfirmationDate'">{{ rowData[col.field] | localToUtc:'MM/dd/yyyy' }}</ng-container>
            <ng-container *ngSwitchDefault>{{rowData[col.field]}}</ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No 1:1 NIBIN links found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <button type="button" (click)="closeForm.emit()" label="Close" class="btn btn-active my-3">Close</button>
</section>

